import { MenuItem } from '@wheere-front/shared-util';
import { CUSTOMER_ROLES, DEVICE_ROLES, GATEWAY_ROLES, Role, SITE_ROLES, USER_ROLES } from './role.model';

export type Domain = 'devices' | 'gateways' | 'sites' | 'trackers' | 'users' | 'customers' | 'manage' | 'tools';

export const domainList: Domain[] = ['trackers', 'gateways', 'sites', 'users', 'customers', 'manage'];

export const domainColors = {
  devices: '#F7067D',
  trackers: '#F7067D',
  gateways: '#FFC800',
  sites: '#5000CD',
  users: '#23D2CD',
  customers: '#2563eb',
  manage: '#8c564b',
  tools: '#107DED',
};

export const domainBadgeColorClass: Record<Domain, string> = {
  devices: 'bg-primary-50 text-primary-500',
  trackers: 'bg-primary-50 text-primary-500',
  gateways: 'bg-yellow-50 text-yellow-400',
  sites: 'bg-eletricPurple-50 text-eletricPurple-500',
  users: 'bg-aquamarine-50 text-aquamarine-500',
  customers: 'bg-secondary-50 text-secondary-500',
  manage: 'bg-slate-100 text-slate-700',
  tools: 'bg-pacificBlue-50 text-pacificBlue-500',
};

export type MenuItemRoles = MenuItem & { roles: Role[] };

export const domainMenuItemsShortcut: MenuItemRoles[] = [
  {
    label: 'home',
    path: '/home',
    roles: [],
  },
  {
    label: 'devices',
    path: '/devices',
    icon: 'module',
    color: domainColors.devices,
    roles: DEVICE_ROLES,
  },
  {
    label: 'gateways',
    path: '/gateways',
    icon: 'gateway',
    color: domainColors.gateways,
    roles: GATEWAY_ROLES,
  },
  {
    label: 'sites',
    path: '/sites',
    icon: 'site',
    color: domainColors.sites,
    roles: SITE_ROLES,
  },
  {
    label: 'users',
    path: '/users',
    icon: 'user',
    color: domainColors.users,
    roles: USER_ROLES,
  },
  {
    label: 'manage',
    path: '/manage',
    icon: 'shield',
    color: domainColors.manage,
    roles: ['PLATFORM_ADMIN'],
  },
  {
    // Outils de terrain faisables depuis le bureau (appariement lidar) : mêmes rôles que Sites,
    // puisque leur résultat se dépose dans un site.
    label: 'tools',
    path: '/tools',
    icon: 'tools',
    color: domainColors.tools,
    roles: SITE_ROLES,
  },
  {
    label: 'customer',
    path: '/customers', // Ce chemin sera remplacé dynamiquement par l'URL de l'application customer
    icon: 'customer',
    color: domainColors.customers,
    roles: CUSTOMER_ROLES,
  },
];
